import React from "react";

import { StyledRegistrationLayout } from "./styles";

export const RegistrationLayout: React.FC = ({ children }) => (
  <StyledRegistrationLayout>{children}</StyledRegistrationLayout>
);
